import React from "react";

import { PlantingTipAppearsInAppNote } from "./plantingTipFooter";

export const PLANTING_SEED_CALIBRATION_HELP_TITLE =
  "Calibração e conferência da plantadeira — semente";

export function PlantingSeedCalibrationHelpContent() {
  return (
    <>
      <p>
        Use no <strong>início do plantio</strong> ou em{" "}
        <strong>conferências de rotina</strong> para verificar a precisão da
        dosagem de sementes.
      </p>
      <p>
        <strong>Procedimento recomendado</strong>
      </p>
      <ol>
        <li>
          <strong>Identifique os módulos de regulagem:</strong> em plantadeiras
          com dosadores elétricos individuais, este procedimento talvez não
          possa ser aplicado (consulte o monitor). Para máquinas mecânicas ou a vácuo
          com caixas separadas (lado esquerdo/direito) ou conjuntos em tandem
          (até 4 caixas), faça o teste em{" "}
          <strong>pelo menos uma linha de cada seção de regulagem</strong> e em
          linhas suspeitas.
        </li>
        <li>
          <strong>Preencha os discos e tire a folga:</strong> baixe a
          plantadeira e ande o suficiente para tirar a folga do
          cardã/transmissão e{" "}
          <strong>
            garantir que todos os furos dos discos estejam totalmente
            preenchidos por sementes
          </strong>
          .
        </li>
        <li>
          <strong>Marque a posição:</strong> com os discos cheios, faça a
          marcação de referência visual no <strong>disco dosador</strong> e no{" "}
          <strong>solo</strong>.
        </li>
        <li>
          Se possível, instale <strong>copos de coleta</strong> nos{" "}
          <strong>condutores de semente</strong>.
        </li>
        <li>
          <strong>Percorra a distância:</strong> em menor marcha possível, ande
          com o trator até os discos completarem no mínimo{" "}
          <strong>3 voltas inteiras</strong>. Pare exatamente na marcação.
        </li>
        <li>
          <strong>Meça o trecho:</strong> anote a distância exata (em metros)
          percorrida pela máquina no solo.
        </li>
        <li>
          <strong>Calcule o esperado:</strong> quantidade de furos do trecho ÷
          metros percorridos.
        </li>
        <li>
          <strong>Confira o real:</strong> conte as sementes que realmente
          caíram por metro em cada linha testada.
        </li>
      </ol>
      <p>
        <strong>Por que fazer este procedimento?</strong> Garante que todas as
        caixas de transmissão estejam reguladas por igual, evita falsos erros
        por discos desabastecidos e previne falhas de plantio por sementes
        duplas ou desregulagem por seção.
      </p>
      <p>
        <strong>Depois da conferência: check a cada abastecimento</strong>
      </p>
      <p>
        Este procedimento vale para o início do plantio ou conferência de
        rotina. No dia a dia, faça o check de calibragem{" "}
        <strong>a cada abastecida</strong>, na semente e no adubo: informe os
        hectares do painel da plantadeira e a quantidade colocada. A
        plataforma acompanha a dosagem. Se sair da margem de{" "}
        <strong>5%</strong>, aparece alerta visual na plataforma e no app.
      </p>
      <PlantingTipAppearsInAppNote />
    </>
  );
}
